import { forwardRef } from "react";
import { Narrative } from "../../store/adsPageStore";

interface NarrativeSidebarElementProps {
  narrative: Narrative;
  selectedNarrative: Narrative | null;
  setSelectedNarrative: (narrative: Narrative) => void;
}

export const NarrativeSidebarElement = forwardRef<HTMLDivElement, NarrativeSidebarElementProps>(
  ({ narrative, selectedNarrative, setSelectedNarrative }, ref) => {
    const isSelected = selectedNarrative?.id === narrative.id;

    return (
      <div ref={ref}>
        <div
          className={`p-4 border rounded-lg cursor-pointer ${
            isSelected ? "bg-gray-100 text-black" : "hover:bg-gray-100"
          }`}
          onClick={() => setSelectedNarrative(narrative)}
        >
          <div className="flex justify-between items-start">
            <h3 className="text-md font-semibold">{narrative.narrative_name}</h3>
            {/* {narrative.is_recorded && (
              <div className="rounded-full bg-black-100 p-0.5 border border-black">
                <Check className="w-3 h-3 text-black" />
              </div>
            )} */}
          </div>
         <p className="text-xs text-gray-500 mt-2 truncate">
            Producto: {
              narrative.product_information?.name
                ? narrative.product_information.name
                : "N/A"
            }
         </p>
          <p className="text-xs text-gray-500 mt-2">
            Angulo: {narrative.sale_angle ?? "N/A"}
          </p>
        </div>
      </div>
    );
  }
);
